import {
    apiClient,
} from "@leap4/frontend";

import {HomeUrl} from "../../../config/generals";

export async function getUpdatedAt(startDate: string, endDate: string, specificComparisonDate?: Date) {
    const baseUrl = `${HomeUrl}/overview/lastUpdatedAt`;
    const apiResponse = await apiClient.post(baseUrl, {
      startDate,
      endDate,
      specificComparisonDate: specificComparisonDate || null
    });
    const updatedAtResponse: Date = new Date(apiResponse.data);
    return updatedAtResponse;
  }
